import React, { useReducer } from "react";
import { RegisterPayload } from "src/library/types/types";
import { initialGlobalState } from "./initialState";

const ACTIONS = {
  UPDATE_FORM_DATA: "update-form-data",
  FORM_AVAILABLE: "update-form-available",
};

interface HackathonState {
  registrationsAvailable: boolean;
  formData: RegisterPayload;
}

type HackathonDispatch = {
  type: string;
  payload: Partial<RegisterPayload> | boolean;
};

interface HackathonContext {
  state: HackathonState;
  dispatch: React.Dispatch<HackathonDispatch>;
}

const GlobalStateContext = React.createContext<HackathonContext | undefined>(undefined);

const useHackathonContext = () => {
  const context = React.useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useHackathonContext must be used within a GlobalStateContext");
  }
  return context;
};

const GlobalStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialGlobalState);

  function reducer(state: HackathonState, action: any) {
    const { type, payload } = action;
    switch (type) {
      case ACTIONS.UPDATE_FORM_DATA:
        return {
          ...state,
          formData: {
            ...state.formData,
            ...payload,
          },
        };
      case ACTIONS.FORM_AVAILABLE:
        return {
          ...state,
          registrationsAvailable: payload,
        };
      default:
        return state;
    }
  }

  return (
    <GlobalStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export { GlobalStateProvider, useHackathonContext, ACTIONS };
